"use strict";

define('app/template/list/template.list.controller',['require','exports','module','evisions/helper','evisions/helper/array','e3-modal','e3-table','rs/models/template','rs/abstract.content.controller','app/template/list/template.list.view','app/template/list/template.detail.view','evisions/validation','langs'],function (require, exports, module) {
  var EVIHelper = require('evisions/helper');
  var EVIHelperArray = require('evisions/helper/array');
  var E3Modal = require('e3-modal');
  var E3Table = require('e3-table');
  var RSTemplateModel = require('rs/models/template');
  var AbstractContentController = require('rs/abstract.content.controller');
  var TemplateListView = require('app/template/list/template.list.view');
  var TemplateDetailView = require('app/template/list/template.detail.view');
  var validation = require('evisions/validation');
  var langs = require('langs');
  var TemplateListController = AbstractContentController.extend({
    DocumentTitle: 'Template List',
    contentName: 'template-list-content abstract-content fixed-header off-white',
    properties: ['documentType', 'columns', 'currentRevisionList', 'selectedTemplate', 'selectedRevision', 'tableController', 'templateTypes'],
    templateExt: 'etemplate',
    maxVisibleRevisions: 4,
    validators: {
      'templateTitle': [validation.empty('Please enter a valid template title.'), validation.checkLength(3, 40)],
      'templateType': [validation.empty('Please select a valid template type.')]
    },
    columns: [{
      name: 'title',
      displayName: 'Title',
      type: 'String',
      width: '70%'
    }, {
      name: 'type',
      displayName: 'Type',
      type: 'String',
      width: '15%'
    }, {
      name: 'activityDate',
      displayName: 'Updated',
      type: 'Date',
      width: '15%'
    }],
    initialize: function initialize() {
      var that = this;
      this.setTableController(new E3Table.AccordionController({
        delegate: this,
        groupedItems: true,
        columns: this.getColumns(),
        groupedItemsKey: 'activelyPublished',
        itemView: TemplateDetailView,
        theme: 'rs',
        ariaLabel: langs.phrase('Settings.Templates.List.ARIALabel')
      }));
      this._super.apply(this, arguments);
      this.registerTableController(this.getTableController());
    },
    viewIsAvailable: function viewIsAvailable() {
      this.getTableController().setup(this.getView().getGridContainer());
      this._super();
    },
    start: function start(documentType, index, direction) {
      var that = this;
      documentType = documentType || RSTemplateModel.DOCUMENT_TYPES.SUBMISSION;
      this.setDocumentType(documentType.toLowerCase());
      return this.requestTemplateTypes(documentType).bind(this).then(function (templateTypes) {
        if (_.isEmpty(templateTypes)) {
          throw new Error("There are no template types for this document type.");
        }
        this.setTemplateTypes(templateTypes);
        this.render();
        return this.getTableController().start();
      });
    },
    setupView: function setupView() {
      this.setView(new TemplateListView());
    },
    getGroupName: function getGroupName(value) {
      return value ? 'Published Templates' : 'Non-Published Templates';
    },
    getTemplateProperties: function getTemplateProperties() {
      return {
        documentType: this.getDocumentType(),
        templateTypes: this.getTemplateTypes(),
        canImport: true,
        canCreate: this.checkPermission('EFORMS_CREATE_TEMPLATE')
      };
    },
    getData: function getData() {
      return RSTemplateModel.listLatestTemplateRevisions(this.getDocumentType());
    },
    refreshAndSelectTable: function refreshAndSelectTable(template) {
      var table = this.getTableController();
      return Promise.bind(this).tap(function () {
        if (!template) {
          return table.clearSelectedItems();
        }
      }).tap(function () {
        return table.refresh();
      }).tap(function () {
        var selected = this.getTableController().getSelectedItem();
        if (template && (!selected || template.id !== selected.id)) {
          return table.selectItemById(template.id);
        }
      }).tap(function () {
        var selected = this.getTableController().getSelectedItem(),
          el = null;
        if (selected) {
          el = table.getView().getTableRowById(selected.id);
          this.getView().scrollToElement(el, true);
        }
      });
    },
    requestFilter: function requestFilter(filterText) {
      this.getTableController().setFilter(filterText);
    },
    getSelectedTemplateRevisions: function getSelectedTemplateRevisions() {
      return this.getSelectedTemplate().getRevisionList() || [];
    },
    tableItemWasSelected: function tableItemWasSelected(item) {
      var template = item.item;
      this.setSelectedTemplate(template);
      this.setSelectedRevision(template);
      return template.requestRevisions().bind(this).tap(function (revs) {
        this.setCurrentRevisionList(revs);
      });
    },
    requestSelectTemplateRevision: function requestSelectTemplateRevision(id) {
      var template = this.getSelectedTemplate().getRevisionList()[id];
      if (template) {
        this.setSelectedRevision(template);
        this.getTableController().refreshSelectedItemView();
      }
    },
    requestNextTemplateRevisions: function requestNextTemplateRevisions() {
      var template = this.getSelectedTemplate(),
        revisions = _.reject(this.getSelectedTemplateRevisions(), function (r) {
          return r.published;
        }),
        currentIndex = template._currentIndex || 0,
        visibleCount = this.maxVisibleRevisions;
      if (template) {
        currentIndex += visibleCount;
        if (currentIndex >= revisions.length) {
          currentIndex -= visibleCount;
        }
        template._currentIndex = currentIndex;
        this.getTableController().refreshSelectedItemView();
      }
    },
    requestPreviousTemplateRevisions: function requestPreviousTemplateRevisions() {
      var template = this.getSelectedTemplate(),
        revisions = _.reject(this.getSelectedTemplateRevisions(), function (r) {
          return r.published;
        }),
        currentIndex = template._currentIndex || 0,
        visibleCount = this.maxVisibleRevisions;
      if (template) {
        currentIndex -= visibleCount;
        if (currentIndex < 0) {
          currentIndex = 0;
        }
        template._currentIndex = currentIndex;
        this.getTableController().refreshSelectedItemView();
      }
    },
    requestTemplateTypes: function requestTemplateTypes(documentType) {
      return RSTemplateModel.requestTemplateTypes(documentType);
    },
    requestTemplateCreate: function requestTemplateCreate() {
      if (this.validate()) {
        var view = this.getView(),
          json = view.getImportJSON(),
          file = this._importFileData,
          formValues = view.getFormValues();
        Promise.bind(this).then(function () {
          if (!file) {
            return RSTemplateModel.createFormTemplate(formValues.title, formValues.description, formValues.type);
          } else {
            return RSTemplateModel.importFormTemplate({
              file: file,
              data: formValues
            });
          }
        }).tap(function (template) {
          view._resetForm();
          view.closeCreateForm();
          this._importFileData = null;
          return this.refreshAndSelectTable(template);
        }).lastly(this.showLoading());
      }
    },
    selectImportFile: function selectImportFile(file) {
      var shouldAllowSelection = false;
      if (file) {
        if (file.name.match(/\.etemplate$/)) {
          shouldAllowSelection = true;
        } else {
          E3Modal.BtnMsgModal.show({
            title: 'Warning',
            message: "Only *.etemplate files are allowed to be imported.",
            buttons: ['OK']
          });
        }
      }
      if (shouldAllowSelection) {
        this._importFileData = file;
        this.getView().setImportTemplateDisplay(file.name);
      } else {
        this._importFileData = null;
        this.getView().setImportTemplateDisplay('');
      }
    },
    requestImportJSON: function requestImportJSON(template, json) {
      var map = {},
        targetMap = {},
        counter = [],
        _mapObjects = null;
      _mapObjects = function mapObjects(obj) {
        counter.push(obj.dataId);
        map[obj.dataId] = obj;
        _.each(obj.dependencies, mapDependencies);
        _.each(obj.children, _mapObjects);
      };
      mapDependencies = function mapDependencies(dep) {
        var deps = targetMap[dep.targetId] || (targetMap[dep.targetId] = []);
        deps.push(dep);
      };
      updateObjects = function updateObjects(oldId, newId) {
        map[oldId].dataId = newId;
        var targets = targetMap[oldId],
          len = targets ? targets.length : 0,
          i = 0;
        for (i = 0; i < len; ++i) {
          targets[i].targetId = newId;
        }
      };
      _.each(json.attachments, _mapObjects);
      _.each(json.children, _mapObjects);
      return RSTemplateModel.requestNewEFIDs(counter.length).then(function (ids) {
        for (var i = 0, len = counter.length; i < len; ++i) {
          updateObjects(counter[i], ids[i]);
        }
        var str = JSON.stringify(json);
        return template.save(str);
      });
    },
    requestTemplateSave: function requestTemplateSave() {
      var that = this,
        formValues = this.getView().getFormValues(),
        template = this.getSelectedTemplate();
      if (this.validate(['templateTitle'])) {
        var saveObj = {
          id: template.getId(),
          revisionNumber: template.getRevisionNumber(),
          title: formValues.title,
          description: formValues.description
        };
        RSTemplateModel.updateFormTemplate(saveObj).bind(this).tap(function (newTemplate) {
          return this.getTableController().clearSelectedItems();
        }).tap(function () {
          return this.getTableController().refresh();
        }).lastly(this.showLoading());
      }
    },
    requestTemplateRevisionEdit: function requestTemplateRevisionEdit() {
      var templateRevision = this.getSelectedRevision(),
        that = this;
      if (templateRevision) {
        if (templateRevision.getReadOnly()) {
          E3Modal.BtnMsgModal.show({
            title: 'Edit Template Revision',
            message: 'This revision has already been published. If you want to edit it a new revision will be created when you save.',
            buttons: ['Cancel', {
              text: 'Edit',
              color: 'primary'
            }]
          }).bind(this).then(function (btn) {
            if (btn == 'Edit') {
              this.getAppController().navigateTemplate(templateRevision, {
                trigger: true
              });
            }
          });
        } else {
          this.getAppController().navigateTemplate(templateRevision, {
            trigger: true
          });
        }
      }
    },
    requestTemplateDelete: function requestTemplateDelete() {
      var template = this.getSelectedTemplate();
      E3Modal.BtnMsgModal.show({
        title: 'Delete Template',
        message: 'Are you sure you want to delete this template and ALL its revisions?',
        buttons: ['Cancel', {
          text: 'Delete',
          color: 'danger'
        }]
      }).bind(this).then(function (btn) {
        if (btn == 'Delete') {
          return template['delete']().bind(this).tap(function () {
            return this.getTableController().clearSelectedItems();
          }).tap(function () {
            return this.getTableController().refresh();
          }).lastly(this.showLoading());
        }
      });
    },
    requestTemplateRevisionDelete: function requestTemplateRevisionDelete() {
      var template = this.getSelectedTemplate(),
        templateRevision = this.getSelectedRevision(),
        willDeleteTemplate = template.getRevisionList().length == 1,
        confirm = 'Delete';
      return Promise.bind(this).tap(function () {
        if (!templateRevision) {
          throw new Promise.IgnoredError();
        }
      }).then(function () {
        return E3Modal.BtnMsgModal.show({
          title: willDeleteTemplate ? 'Delete Template' : 'Delete Template Revision',
          message: willDeleteTemplate ? 'This is the last revision.  Are you sure you want to delete this template?' : 'Are you sure you want to delete this template revision? All other revisions will be unaffected.',
          buttons: ['Cancel', {
            text: confirm,
            color: 'danger'
          }]
        });
      }).tap(function (btn) {
        if (btn != confirm) {
          throw new Promise.IgnoredError();
        }
      }).tap(function () {
        if (willDeleteTemplate) {
          return template['delete']();
        }
        return templateRevision.deleteRevision();
      }).tap(function () {
        if (willDeleteTemplate) {
          return this.getTableController().clearSelectedItems();
        }
      }).tap(function () {
        if (willDeleteTemplate) {
          return this.getTableController().refresh();
        } else {
          return this.refreshAndSelectTable(template);
        }
      });
    },
    requestTemplateRevisionPublish: function requestTemplateRevisionPublish() {
      var templateRevision = this.getSelectedRevision(),
        that = this;
      return Promise.bind(this).tap(function () {
        if (templateRevision.getPublished()) {
          throw new Promise.IgnoredError();
        }
      }).then(function () {
        return E3Modal.BtnMsgModal.show({
          title: 'Publish Template Revision',
          message: 'Are you sure you want to publish this template? ' + 'Continuing will mark this revision as read-only and any new submissions of this type will use this template.',
          buttons: ['Cancel', 'Publish']
        });
      }).tap(function (btn) {
        if (btn != 'Publish') {
          throw new Promise.IgnoredError();
        }
      }).tap(function () {
        return templateRevision.publish()["finally"](that.showLoading());
      }).tap(function () {
        return this.refreshAndSelectTable(templateRevision)["finally"](that.showLoading());
      });
    },
    requestTemplateRevisionPreview: function requestTemplateRevisionPreview() {
      var url = this.getAppController().navigateTemplate(this.getSelectedRevision(), null, null, true, true),
        ref = location.pathname + '#' + url;
      window.open(ref, '_blank');
    },
    requestViewAllRevisions: function requestViewAllRevisions() {
      var revisions = this.getSelectedTemplateRevisions();
    },
    getTemplateDetails: function getTemplateDetails() {
      var revisions = this.getCurrentRevisionList(),
        nonPublished = [],
        published = null,
        revision = null,
        template = this.getSelectedTemplate(),
        selectedRevision = this.getSelectedRevision(),
        i = 0,
        len = revisions ? revisions.length : 0,
        selected = null,
        currentIndex = template._currentIndex || 0,
        visibleCount = this.maxVisibleRevisions;
      for (i = 0; i < len; ++i) {
        revision = {
          index: i,
          selected: false,
          data: revisions[i]
        };
        if (revision.data.revisionNumber == selectedRevision.revisionNumber) {
          selected = revision;
          revision.selected = true;
        }
        if (revision.data.published) {
          published = revision;
        } else {
          nonPublished.push(revision);
        }
      }
      return {
        revisions: nonPublished.slice(currentIndex, currentIndex + visibleCount),
        pageNumber: currentIndex / visibleCount + 1,
        pageCount: Math.ceil(nonPublished.length / visibleCount),
        hasNext: currentIndex < nonPublished.length - visibleCount,
        hasPrevious: currentIndex > 0,
        hasMore: nonPublished.length > visibleCount,
        revisionCount: nonPublished.length,
        modifyPerm: this.checkPermission('EFORMS_MODIFY_TEMPLATE'),
        deletePerm: this.checkPermission('EFORMS_DELETE_TEMPLATE'),
        publishPerm: this.checkPermission('EFORMS_PUBLISH_TEMPLATE'),
        canDelete: selected ? !selected.data.readOnly : false,
        canPublish: selected ? !selected.data.published : false,
        download: selected ? selected.data.getDownloadLink() : false,
        published: published,
        selected: selected,
        latest: template
      };
    },
    processFilter: function processFilter(items, filter) {
      return _.filter(items, function (item) {
        if (String(item.item.title).toLowerCase().indexOf(String(filter).toLowerCase()) !== -1) {
          return true;
        } else if (String(item.item.type).toLowerCase().indexOf(String(filter).toLowerCase()) !== -1) {
          return true;
        }
      });
    },
    processGroupSort: function processGroupSort(groups) {
      return _.sortBy(groups, function (group) {
        return group.name;
      }).reverse();
    }
  }, {
    requiredPermissions: ['EFORMS_VIEW_TEMPLATE']
  });
  module.exports = TemplateListController;
});

